var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{ref:"input",staticClass:"v-switch",attrs:{"type":_vm.$attrs.type,"on-label":_vm.onLabel,"off-label":_vm.offLabel,"checked":_vm.value==_vm.onValue},on:{"click":_vm.change}},[_c('div',{staticClass:"v-switch-slider"})])}
var staticRenderFns = []

export { render, staticRenderFns }